import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { Text } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { ReactThreeFiber, useLoader } from '@react-three/fiber'
import {  useThree, useFrame } from '@react-three/fiber'
import LSystem  from './LSystem';
import { typeImplementation } from '@testing-library/user-event/dist/type/typeImplementation';


let tempText = '';
function addPath(temp, turtle, text, sIndex) {
  let angle = Math.PI / 6;

  let i = sIndex;
  while(i < text.length) {
    tempText += text[i];
    if(text[i] === 'F') {
      
      const start = turtle.position.clone();

      temp.push({ start, rotation: turtle.rotation.clone() });

      let dir = new THREE.Vector3();
      turtle.getWorldDirection(dir);

      // temp.push({ start: turtle.position.clone().add(dir.clone().multiplyScalar(5)), rotation: turtle.rotation.clone() });
      turtle.position.add(dir.multiplyScalar(10));
      // console.log(turtle.rotation)
      turtle.updateMatrix();
      
    }
    else if(text[i] === '/') {
      turtle.rotateY(angle );
    }
    else if(text[i] === '\\') {
      turtle.rotateY(-angle );
    }
    else if(text[i] === '^') {
      turtle.rotateX(angle);
    }
    else if(text[i] === '&') {
      turtle.rotateX(-angle);
    }
    else if(text[i] === '+') {
      turtle.rotateZ(angle);
    }
    else if(text[i] === '-') {
      turtle.rotateZ(-angle);
    }
    else if(text[i] === ')') 
      return i;
    else if(text[i] === '(') {
      i = addPath(temp, turtle.clone(), text, i + 1);
      // i = text.indexOf(')', i);
    }
    i++;
  }

}

function rand() {
  return Math.random() - 0.5;
}
let adding = true;
function Stairs({ count, radius }) {
  const mesh = useRef();
  const { scene, camera } = useThree();
  let texture = useLoader(THREE.TextureLoader, "noise.png");
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(2,2);

  const dummy = useMemo(() => new THREE.Object3D(), []);

  
  const particles = useMemo(() => {
    const temp = [];
    let turtle = new THREE.Object3D();
    turtle.position.set(0,0,0);
    
    const system = new LSystem();
    // system.rules = [[/[S]/gm, ['RGGS']], [/[R]/gm, ['/', '\\']], [/[G]/gm, ['^FB^FB', '^FB^FB', '&FB&FB']]];
    // system.rules = [[/[S]/gm, ['FF(RB)(RB)(RB)G']], 
    //                 [/[R]/gm, ['^', '&', '+', '-', '/', '\\']], 
    //                 [/[B]/gm, ['FFB', 'FFB', 'FFAB', 'FFAB', 'FF(RRB)B']], 
    //                 [/[G]/gm, ['FF(RB)FF(RB)FFG']],
    //                 [/[A]/gm, ['/', '\\']]];
    system.rules = [[/[S]/gm, ['^^^///FF(B)']], 
                    [/[R]/gm, ['/', '\\']], 
                    [/[B]/gm, ['HB', 'HB', 'HB', 'HB', 'HB', 'HB', 'FF(^^^G)B', 'FF(HB)B']], 
                    [/[H]/gm, ['RFFF']],
                    [/[G]/gm, ['FFAG']],
                    [/[A]/gm, ['&', '^', '+', '-']]];
    system.nextStep(40);

    console.log(system.string);
    let string = '';

    turtle.position.set(0,3,0);
    turtle.lookAt(0,0,0);
    addPath(temp, turtle, system.string, 0);
    console.log(tempText);
    
    // for(let j=0; j < 100; j++)
    // {
    //     turtle.position.set(rand() * 1000, 1, j * 50 + rand() * 10);
    //   for(let i=0; i < (Math.random() + 1) * 40; i++) {
    //     let start = turtle.position.clone().add(new THREE.Vector3(rand() * 10, 5, rand()  * 5));
    //     start.y = i * 5;
    //     turtle.lookAt(start);
    //     temp.push({start, rotation: turtle.rotation.clone()});
    //     turtle.position.copy(start);
    //     turtle.updateMatrix();
    //   }
    // }

    return temp
  }, [count])

  useEffect(() => {
    // if(!adding) return;
    // adding = false;

    // let paths = [[],[],[]];

    // for(let i=0; i < particles.length; i++) {
    //   for(let j=0; j < 3; j++)
    //     paths[j].push(particles[i].start.clone().add(new THREE.Vector3(Math.random() * 10 - 5, Math.random() * 10 - 5, Math.random() * 10 - 5)));
    // }

    // for(let j=0; j < 3; j++) {
    //   let curve = new THREE.CatmullRomCurve3(paths[j]);
    //   const geometry = new THREE.TubeGeometry( curve, 1000, 1, 8, false );
    //   const material = new THREE.MeshBasicMaterial( { map: texture, color: 'green', transparent: true, opacity: 0.5 } );
    //   const meshNew = new THREE.Mesh( geometry, material );
    //   mesh.current.add(meshNew);
    // }
  })

  
  useFrame(({clock, raycaster}) => {
    if(!mesh.current) return;
    
    // Go through each particle
    particles.forEach((particle, i) => {
      
      let { start, rotation } = particle;
      // Change position
      dummy.position.copy(start.clone());
      // dummy.scale.copy(particle.size);
      dummy.scale.set((Math.sin(i / 2 + clock.elapsedTime) + 1) / 6 + 0.05,
                      (Math.sin(i / 2 + clock.elapsedTime) + 1) / 6 + 0.05,
                      1);
      dummy.rotation.copy(rotation);
      
      dummy.updateMatrix();
      // And apply the matrix to the instanced mesh
      mesh.current?.setMatrixAt(i, dummy.matrix);
      mesh?.current.setColorAt(i, new THREE.Color( "hsl( 0, 0%, " + Math.floor((Math.sin(i / 2 + clock.elapsedTime + Math.PI) + 1) * 100) + "%)" ));
      
    })
    if(mesh.current) {
      mesh.current.instanceColor.needsUpdate = true;
      mesh.current.instanceMatrix.needsUpdate = true;
    }

  });

  // let geo = new THREE.CylinderGeometry(2,2,10);
  let geo = new THREE.SphereGeometry(10,16);
  geo.translate(0, 5, 0);
  geo.rotateX(Math.PI / 2);

  return (
    <>
      <instancedMesh ref={mesh} geometry={geo} args={[null, null, count]} >
        <meshStandardMaterial attach="material" bumpMap={texture} bumpScale={10}/>
      </instancedMesh>
    </>
  )
}



function Road({ count }) {
  const mesh = useRef();
  const { scene, camera } = useThree();
  let lastTime = 0;

  const dummy = useMemo(() => new THREE.Object3D(), []);

  useEffect(() => camera.position.set(-2,5,0));
  
  const particles = useMemo(() => {
    const temp = [];
    for (let i = 0; i < count / 2; i++) {
      
      let start = new THREE.Vector3((i - count / 4) * 100 + 25, 0, 0);
      let rotation = new THREE.Vector3(0, Math.PI / 2, 0);

      temp.push({ start, rotation });

      
      start = new THREE.Vector3(0, 0, (i - count / 4) * 100 + 25);
      rotation = new THREE.Vector3(0, 0, 0);

      temp.push({ start, rotation });
    }
    return temp
  }, [count])

  
  useFrame(({clock, raycaster}) => {
    if(!mesh.current) return;
    
    // Go through each particle
    particles.forEach((particle, i) => {
      
      let { start,  rotation } = particle;
      // Change position
      
      if(Math.abs(start.x - camera.position.x) > 1000 || Math.abs(start.z - camera.position.z) > 1000) {
        particle.start.x -= Math.sign(start.x - camera.position.x) * 2000;
        particle.start.z -= Math.sign(start.z - camera.position.z) * 2000;
      }
      
      dummy.position.copy(start);
      dummy.rotation.set(rotation.x, rotation.y, rotation.z);
      dummy.updateMatrix();
      // And apply the matrix to the instanced mesh
      mesh?.current.setMatrixAt(i, dummy.matrix);
      // mesh?.current.setColorAt(i, new THREE.Color( "hsl(" + Math.floor(Math.random() * 255) + ", 80%, 10%)" ));

    })
    mesh.current.instanceMatrix.needsUpdate = true;

    lastTime = clock.elapsedTime;
  })
  return (
    <>
      <instancedMesh ref={mesh} geometry={new THREE.BoxGeometry(10000, 1, 25)} args={[null, null, count]}>
        <meshBasicMaterial attach="material" color={0xaaaaaa}/>
      </instancedMesh>
    </>
  )
}

export { Stairs, Road };